export const isGhostUser = state => (!!state.user.user && !!state.user.user.isGhostUser);